module.exports = __webpack_public_path__ + "img/btn.c4459caa.png";